import React, { Fragment } from "react";
import { Link } from "react-router-dom";
import { Row, Col, Card, CardBody } from "reactstrap";
import PhoneBreakpoint from "../../../context/phone_breakpoint";
import { Tooltip } from "../../../core";
import { CardImageWithLoad } from "../../../helper/cardImageWithLoad";
import { CustomCheckBox } from "../../../helper/customCheckBox";
import { formatCurrentlyPlayingForGrid } from "../utls/currentlyPlayingFormatter";

// const checkCurrentlyPlaying = device => {
//   const { calendar_name, campaign_name } = device.attributes;
//   const { id } = device;
//   if (!campaign_name && !calendar_name) {
//     return "Not Playing";
//   }
//   return formatCurrentlyPlaying(
//     { campaign_name, calendar_name, id },
//     "current"
//   );
// };

const NetworkGroupDeviceGrid = ({
  devices,
  selectedGroupID,
  selectedGroupName,
  removeDevice,
  toggleDrawer,
  toggleSendToDevice,
  stopPlayingDevice,
  forwardRef,
  className,
  id,
  selectedDeviceInGroup,
  change,
  refreshScreenShot,
  isRefreshing,
  currentRefreshingId
}) => (
  <div ref={forwardRef} id={id} className="screenShot_container ">
    <Row className="network-grid-row">
      {devices.length ? (
        devices.map(device => (
          <Col xs="12" sm="8" md="6" lg="4">
            <Card className="screenShot_container__screen">
              {" "}
              <CardBody>
                <div
                  role="presentation"
                  className="screenShot_container__imageWrapper"
                >
                  <Link
                    to={{
                      pathname: `/networks/device/${device.id}?id=${selectedGroupID}&gn=${selectedGroupName}&n=${device.attributes.name}&view=groups`,
                      state: {
                        groupID: selectedGroupID,
                        groupName: selectedGroupName,
                        name: device.attributes.name || ""
                      }
                    }}
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={e => e.stopPropagation()}
                  >
                    <div>
                      <CardImageWithLoad
                        url={device.attributes.s3_screenshot_url}
                        useNoScreenshot
                      />
                    </div>
                    <PhoneBreakpoint>
                      <CustomCheckBox
                        item={device}
                        selectedList={selectedDeviceInGroup}
                        formField="selectedDevicesInGroup"
                        change={change}
                        fromNetwork
                      />
                    </PhoneBreakpoint>
                    <div
                      className="imageOverlay imageOverlay--mod"
                      style={{
                        bottom:
                          selectedDeviceInGroup.filter(i => i.id === device.id)
                            .length > 0 && 0
                      }}
                    >
                      <CustomCheckBox
                        item={device}
                        selectedList={selectedDeviceInGroup}
                        formField="selectedDevicesInGroup"
                        change={change}
                        fromNetwork
                      />
                      <div className="actionButtonWrapper actionButtonWrapper--mod">
                        {" "}
                        <Tooltip
                          item={
                            <i
                              role="presentation"
                              onClick={e => {
                                e.stopPropagation();
                                e.preventDefault();
                                return removeDevice(device);
                              }}
                              style={{ cursor: "pointer" }}
                              className="fas fa-trash"
                            />
                          }
                          id={`remove-${device.id}`}
                          tooltipContent="Remove Device"
                        />
                        <Tooltip
                          item={
                            <i
                              role="presentation"
                              onClick={e => {
                                e.stopPropagation();
                                e.preventDefault();
                                return toggleDrawer(device);
                              }}
                              style={{ cursor: "pointer" }}
                              className="fas fa-cog"
                            />
                          }
                          id={`setting-${device.id}`}
                          tooltipContent="Advanced Setting"
                        />
                      </div>
                      <div className="centerAlignedDiv">
                        <span>View Device</span>
                      </div>
                    </div>
                  </Link>
                </div>
                <div className="d-flex screenShot_container__textWrapper">
                  <div className="mr-auto screenShot_container__hostName">
                    {device.attributes.name &&
                    device.attributes.name.length >= 20 ? (
                      <Tooltip
                        item={
                          <span>
                            {" "}
                            {`${device.attributes.name.slice(0, 20)}...`}{" "}
                          </span>
                        }
                        id={`viewname-${device.id}`}
                        tooltipContent={device.attributes.name}
                      />
                    ) : (
                      <span>{device.attributes.name}</span>
                    )}
                    {!device.attributes.name && <span>N/A</span>}
                  </div>
                  <div className="screenShot_container__buttonsWrapper">
                    {(device.attributes.campaign_name ||
                      device.attributes.calendar_name) && (
                      <div
                        role="presentation"
                        className="screenShot_container__buttonsWrapper-buttons"
                        onClick={e => {
                          e.stopPropagation();
                          return stopPlayingDevice(device);
                        }}
                      >
                        <Tooltip
                          item={
                            <i
                              role="presentation"
                              style={{ cursor: "pointer" }}
                              className="fas fa-stop"
                            />
                          }
                          id={`delete-${device.id}`}
                          tooltipContent="Stop"
                        />
                      </div>
                    )}
                    <div
                      role="presentation"
                      className="screenShot_container__buttonsWrapper-buttons refreshButton"
                      onClick={e => {
                        e.stopPropagation();
                        return refreshScreenShot(device);
                      }}
                    >
                      <Tooltip
                        item={
                          <i
                            role="presentation"
                            style={{ fontSize: "20px" }}
                            className={`bx bx-revision ${
                              isRefreshing && currentRefreshingId === device.id
                                ? "refresh-rotate "
                                : ""
                            }`}
                          />
                        }
                        id={`refresh-${device.id}`}
                        tooltipContent="Refresh Screenshot"
                      />
                    </div>
                    <div
                      role="presentation"
                      className="screenShot_container__buttonsWrapper-buttons"
                      onClick={e => {
                        e.stopPropagation();
                        return toggleSendToDevice(device);
                      }}
                    >
                      <Tooltip
                        item={
                          <i
                            role="presentation"
                            style={{ cursor: "pointer" }}
                            className="fas fa-play"
                          />
                        }
                        id={`play-${device.id}`}
                        tooltipContent="Play"
                      />
                    </div>

                    <span
                      className={`screenShotButton screenShotButton--grid screenShot_container${
                        device.attributes.status === "online"
                          ? "__activeStatus"
                          : "__offlineStatus"
                      }`}
                    >
                      {device.attributes.status || "N/A"}{" "}
                    </span>
                  </div>
                </div>
                <span style={{ fontSize: "14px" }}>
                  <span>
                    {formatCurrentlyPlayingForGrid(
                      {
                        campaign_name: device.attributes.campaign_name,
                        calendar_name: device.attributes.calendar_name,
                        id: device.id
                      },
                      "current"
                    )}
                  </span>{" "}
                </span>
              </CardBody>
            </Card>
          </Col>
        ))
      ) : (
        <span className="null-message-info">No Data</span>
      )}
    </Row>
  </div>
);

export default NetworkGroupDeviceGrid;
